import apiClient from '../api/apiClient';

export interface MentorData {
  fullSaved: boolean;
  name: string;
  email: string;
  department: string;
  tags?: string;  // string[] 대신 쉼표로 구분된 문자열로 변경
  categoryName?: string;
  imageUrl?: string;
  bannerUrl?: string;
  introduction?: string; // introductionImageUrl을 introduction으로 변경
}

export interface MentorResponse {
  id: number;
  name: string;
  email: string;
  department: string;
  tags?: string[];
  categoryName?: string;
  imageUrl?: string;
  bannerUrl?: string;
  introductionImageUrl?: string; // introduction을 introductionImageUrl로 변경
  createdAt: string;
  updatedAt: string;
}

class MentorApiService {
  private baseUrl = '/api/admin/mentors';

  /**
   * 멘토 등록
   */
  async createMentor(mentorData: MentorData): Promise<MentorResponse> {
    try {
      /// console.log('🚀 멘토 등록 API 요청 데이터:', mentorData);
      
      const response = await apiClient.post(this.baseUrl, mentorData);

      /// console.log('✅ 멘토 등록 API 성공 응답:', response.data);
      return response.data;
    } catch (error) {
      /// console.error('💥 멘토 등록 오류:', error);
      throw error;
    }
  }

  /**
   * 멘토 목록 조회
   */
  async getMentors(page: number = 1, size: number = 10): Promise<MentorResponse[]> {
    try {
      const response = await apiClient.get(`${this.baseUrl}/list?page=${page}&size=${size}`);
      return response.data.data.content;
    } catch (error) {
      /// console.error('멘토 목록 조회 오류:', error);
      throw error;
    }
  }

  /**
   * 특정 멘토 조회
   */
  async getMentor(id: number): Promise<MentorResponse> {
    try {
      const response = await apiClient.get(`${this.baseUrl}/${id}`);
      return response.data;
    } catch (error) {
      /// console.error('멘토 정보 조회 오류:', error);
      throw error;
    }
  }

  /**
   * 멘토 정보 수정
   */
  async updateMentor(id: number, mentorData: Partial<MentorData>): Promise<MentorResponse> {
    try {
      //  console.log('🔄 멘토 수정 API 요청:', {
      //   url: `${this.baseUrl}/${id}`,
      //   data: mentorData
      // });
      
      const response = await apiClient.put(`${this.baseUrl}/${id}`, mentorData);

      /// console.log('✅ 멘토 수정 API 성공:', response.data);
      return response.data;
    } catch (error) {
      /// console.error('💥 멘토 정보 수정 오류:', error);
      throw error;
    }
  }

  /**
   * 멘토 삭제
   */
  async deleteMentor(id: number): Promise<void> {
    try {
      await apiClient.delete(`${this.baseUrl}/${id}`);
    } catch (error) {
      /// console.error('멘토 삭제 오류:', error);
      throw error;
    }
  }

  /**
   * 임시 저장
   */
  async saveDraft(mentorData: MentorData): Promise<MentorResponse> {
    const draftData = { ...mentorData, fullSaved: false };
    /// console.log('💾 임시 저장 API 요청 데이터:', draftData);
    return this.createMentor(draftData);
  }

  /**
   * 이미지 업로드
   */
  async uploadImage(file: File, type: 'thumbnail' | 'banner' | 'introduction'): Promise<string> {
    try {
      //  console.log('📸 이미지 업로드 API 요청:', { 
      //   fileName: file.name, 
      //   fileSize: file.size, 
      //   fileType: file.type, 
      //   uploadType: type 
      // });

      const formData = new FormData();
      formData.append('image', file);
      formData.append('type', type);

      const response = await apiClient.post('/api/admin/mentors/upload-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      /// console.log('✅ 이미지 업로드 API 성공 응답:', response.data);
      
      // API 응답 구조에 맞게 수정: result.data.image_url
      if (response.data.data && response.data.data.image_url) {
        return response.data.data.image_url;
      } else {
        /// console.error('❌ 예상하지 못한 응답 구조:', response.data);
        throw new Error('이미지 URL을 받지 못했습니다.');
      }
    } catch (error) {
      /// console.error('💥 이미지 업로드 오류:', error);
      throw error;
    }
  }
}

export const mentorApiService = new MentorApiService();
